import React from 'react';
import { ReviewQuestionWrapper } from '../shared/ReviewQuestionWrapper';
import { PairingItem } from '../shared/PairingItems';
import {
  usePairingChoicesMap,
  useDisplayPairs,
  usePairingUserAnswerMap
} from '../../../../../hooks/usePairingData';

const PairingReview = ({ question, userAnswer = [], correctAnswer = [], isCorrect, accuracy, explanation = '', recap = '', annotations = [], reportProps = null }) => {
  // Build choices map using custom hook
  const choicesMap = usePairingChoicesMap(question);

  // Build displayPairs using custom hook
  const displayPairs = useDisplayPairs(question, choicesMap);

  // Parse userAnswer into map using custom hook
  const userAnswerMap = usePairingUserAnswerMap(userAnswer, question, choicesMap);

  // changed by Cursor: debug log untuk trace no answer issue
  console.log('🔍 PairingReview Debug:', {
    userAnswer,
    userAnswerType: typeof userAnswer,
    userAnswerIsArray: Array.isArray(userAnswer),
    userAnswerKeys: typeof userAnswer === 'object' && userAnswer !== null ? Object.keys(userAnswer) : 'N/A',
    displayPairsLeftIdxs: displayPairs.map(p => p.leftIdx),
    userAnswerMapKeys: Object.keys(userAnswerMap),
    questionPairsLeftIdxs: question.pairs?.left?.map(l => l.idx ?? l.id) || 'N/A',
  });

  return (
    <ReviewQuestionWrapper
      questionType="Pairing"
      question={question}
      explanation={explanation}
      recap={recap}
      annotations={annotations}
      reportProps={reportProps}
    >
        <p className="text-base text-[var(--text-primary)] leading-relaxed">{question.text || question['text-soal'] || ''}</p>

      <div className="flex flex-col gap-4 mt-6">
        {displayPairs.length > 0 ? (
          displayPairs.map((pair, i) => {
            const userAnswerData = userAnswerMap?.[pair.leftIdx];
            const userRightIdx = userAnswerData?.rightIdx;
            const isCorrectPair = userRightIdx !== undefined && pair.leftIdx === userRightIdx;
            const hasUserAnswer = userRightIdx !== undefined && userAnswerData?.rightText !== null;

            return (
              <PairingItem
                key={i}
                pair={pair}
                userAnswerData={userAnswerData}
                isCorrectPair={isCorrectPair}
                hasUserAnswer={hasUserAnswer}
              />
            );
          })
        ) : (
          <div className="p-4 px-5 rounded-xl border-2 border-[var(--border-color)] bg-[var(--card-bg)] relative">
            <p className="text-[var(--text-secondary)]">No pairing data available</p>
          </div>
        )}
      </div>

    </ReviewQuestionWrapper>
  );
};

export default PairingReview;

